module.exports = __webpack_public_path__ + "img/Pot2.be343978.svg";